import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import lightBrands from "@/../../hypetrain/static/img/light-brands.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import {
  DARK_PURPLE,
  OPACITY_TRANSITION,
  PUBLIC_CONTENT_MAX_WIDTH,
  SUBTEXT_COLOR,
} from "@/css/constants";
import { cn } from "@/lib/utils";

interface BrandsV2Props {
  opacity?: number;
  title?: string;
  backgroundColor?: string;
  brandSvg?: string;
  className?: string;
}

export function BrandsV2({
  opacity = 1,
  title = "Trusted by talent from top companies",
  backgroundColor = DARK_PURPLE,
  brandSvg = lightBrands,
  className,
}: BrandsV2Props) {
  return (
    <Box css={{ backgroundColor }} className={cn("py-10", className)}>
      <Box css={{ opacity, transition: OPACITY_TRANSITION }}>
        <Flex justifyContent="center" pb={30}>
          <Box color={SUBTEXT_COLOR} textAlign="center">
            <b>{title}</b>
          </Box>
        </Flex>
        <Container maxWidth={PUBLIC_CONTENT_MAX_WIDTH}>
          <BrandContainer>
            <BrandInner>
              <EmbedSvg
                src={brandSvg}
                height={40}
                style={{
                  minWidth: PUBLIC_CONTENT_MAX_WIDTH - 30,
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </BrandInner>
          </BrandContainer>
        </Container>
      </Box>
    </Box>
  );
}

const marquee = keyframes`
  0% { transform: translateX(0); }
  50% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;

const BrandContainer = styled(Box)`
  width: 100%;
  height: 36px;
  position: relative;
  overflow: hidden;
`;

const BrandInner = styled(Box)`
  height: 36px;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${PUBLIC_CONTENT_MAX_WIDTH}px) {
    position: absolute;
    animation: ${marquee} 45s linear infinite;
    will-change: transform;
  }

  @media screen and (min-width: ${PUBLIC_CONTENT_MAX_WIDTH + 1}px) {
    justify-content: center;
  }
`;
